/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommsThreadTextarea/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import Template from './Template/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CommsThreadTextarea({
  children,
  viewPath = "/DesignSystem/CommsThreadTextarea",
  value,
  onChange,
  disabled,
  placeholder,
  maxLength
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onAutocompleteAction = fromHelpers.useOnAutocompleteAction({
  children,
  viewPath,
  value,
  onChange,
  disabled,
  placeholder,
  maxLength
  
})
let onAutocompleteFetch = fromHelpers.useOnAutocompleteFetch({
  children,
  viewPath,
  value,
  onChange,
  disabled,
  placeholder,
  maxLength
  
})
  return (<React.Fragment
>
<Template
  viewPath={`${viewPath}/Template`}
/>
<div
  data-testid="CommsThreadTextarea.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1giHh4': dtColorsNeutral200,'--pl-2-1giHh4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-1giHh4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-4-1giHh4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-1giHh4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-6-1giHh4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-7-1giHh4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block comms-thread-textarea ${styles.Vertical}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 value={value}
 onChange={onChange}
 disabled={disabled}
 toolbar={false}
 menubar={false}
 inline={true}
 selector="comms-thread-textarea"
 autocomplete={true}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 toolbarPersist={false}
 placeholder={placeholder}
 maxLength={maxLength}
 plaintext={true}
 autoFocus={true}
/>
</div>
{children}
</React.Fragment>)
}